// Module
var code = "<template><div id=\"chartdiv-${id}\" class=\"column grow-xs-1\"></div></template>";
// Exports
module.exports = code;